import { Result } from 'antd';
import { Outlet } from 'react-router-dom';

import { useAuth } from '@/providers/auth-provider';

export function RequireRole({ roles }: { roles: string[] }) {
  const { user } = useAuth();
  const ok = user?.roles.some((r) => roles.includes(r));
  if (!ok) {
    return <Result status="403" title="403" subTitle="You don't have access to this page." />;
  }
  return <Outlet />;
}
